import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class BackgroundOutputGrid extends BaseComponent {
	
	static get properties() {
		return {	
			category: {type: String}
		};
	}
	
	constructor() {
		super();
		
		var backGrid = this;
				
		setTimeout(function(){
			backGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var backGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',					
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},	
				{
					tag: 'vaadin-button',	
					itemid: 'download',
					'class': 'spacer-toolbar-item',
					disabled: true,
					children:[
						ElementUtil.makeIcon('vaadin:download', ' Download')
					], 
					listeners: {
						click: function() {
							actionDownload(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'vaadin-button',											
					itemid: 'delete',
					theme: 'error primary',
					'class': 'spacer-toolbar-item',
					style: 'float: right;',				
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}
			]
		});		
		
		var gridColumns = [];
		if (!backGrid.category) {
			gridColumns.push({
				path: 'typeDescription',
				header: 'Type',
				width: '8em'
			});
		}
		gridColumns.push(
			{
				path: 'note',
				header: 'Note',
				width: '9em'
			},
			{
				path: 'inputFileName',
				header: 'Input File name',
				width: '9em'
			},
			{
				path: 'statusDescription',
				header: 'Status',
				'text-align': 'center',
				width: '5em'
			},
			{
				path: 'startDts',
				header: 'Start Date',
				width: '9em',
				renderer: function(root, column, rowData) {
					var date = TimeUtil.parseDate(rowData.item.startDts);
					root.innerHTML = TimeUtil.formatDateStandard(date);
				}
			},
			{
				path: 'completedDts',
				header: 'Completed Date',
				width: '9em',
				renderer: function(root, column, rowData) {
					if (rowData.item.completedDts) {
						var date = TimeUtil.parseDate(rowData.item.completedDts);
						root.innerHTML = TimeUtil.formatDateStandard(date);
					}
				}
			},
			{
				path: 'expirationDate',
				header: 'Expiration Date',
				width: '9em',
				renderer: function(root, column, rowData) {
					if (rowData.item.expirationDate) {
						var date = TimeUtil.parseDate(rowData.item.expirationDate);
						root.innerHTML = TimeUtil.formatDateStandard(date);
					}
				}
			},
			{
				path: 'errorMessage',
				header: 'Error Message',
				width: '9em',
				'flex-grow': '1'
			}
		);

		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: gridColumns,
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {	
						
						if (item.completedDts) {
							ElementUtil.query(toolbar, 'download').disabled = false;
						} else {
							ElementUtil.query(toolbar, 'download').disabled = true;
						}						
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'download').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		backGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			var loadMask = backGrid.showLoading();	
			Service.getBackgroundOutputService().getOutputRecords().then(function(files){
				loadMask.remove();
				
				if (backGrid.category) {
					var filtered = [];
					
					files.data.forEach(function(item){
						if (item.backgroundOutputType === backGrid.category) {
							filtered.push(item);
						}
					});
					grid.items = filtered;					
				} else {
					grid.items = files.data;				
				}
			});
			
		};
		actionRefresh();		
		backGrid.resfreshGrid = actionRefresh;
		
		var actionDownload = function(record) {
			Service.getBackgroundOutputService().downloadOutput(record.outputId);
		};
		
		var actionDelete = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete ' + record.inputFileName + '?',				
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = backGrid.showLoading('Deleting...');
							Service.getBackgroundOutputService().deleteOutput(record.outputId).then(function(results){
								loadMask.remove();
								
								if (results.success) {
									window.DL.MessageUtil.showToast('Success', 'Successful deleted', {									
										theme: 'success'
									});									
								} else {
									window.DL.MessageUtil.showToastError('Unable delete output.', 'Failed');
								}
								actionRefresh();
							});							
						}
					},
					{
						text: 'No'
					}
				]
			});			
			
		};
		
	}
	
	refresh() {
		var backGrid = this;
		backGrid.resfreshGrid();		
	}

};

customElements.define('dl-backgroundoutput-grid', BackgroundOutputGrid);
